(() => {
  const SELECTORS = {
    drawer: "[data-fw-mobile-menu]",
    opener: "[data-fw-menu-open]",
    closer: "[data-fw-menu-close]",
    mobileLink: "[data-fw-mobile-link]",
  };

  let previouslyFocused = null;

  function getDrawerForControl(control) {
    const drawerId = control?.getAttribute("aria-controls");
    return drawerId
      ? document.getElementById(drawerId)
      : control
          ?.closest("[data-fw-header-root]")
          ?.querySelector(SELECTORS.drawer);
  }

  function setDrawerState(drawer, open) {
    if (!drawer) return;

    const root = drawer.closest("[data-fw-header-root]");
    const opener = root?.querySelector(SELECTORS.opener);
    const firstFocusable = drawer.querySelector(
      "a[href], button:not([disabled]), summary",
    );

    drawer.classList.toggle("is-open", open);
    drawer.setAttribute("aria-hidden", String(!open));
    opener?.setAttribute("aria-expanded", String(open));
    document.body.classList.toggle("fw-menu-is-open", open);

    if (open) {
      previouslyFocused = document.activeElement;
      window.requestAnimationFrame(() => firstFocusable?.focus());
    } else if (previouslyFocused instanceof HTMLElement) {
      previouslyFocused.focus();
      previouslyFocused = null;
    }
  }

  function closeAllDrawers() {
    document
      .querySelectorAll(SELECTORS.drawer)
      .forEach((drawer) => setDrawerState(drawer, false));
  }

  function initialiseHeaders(scope = document) {
    scope.querySelectorAll?.("[data-fw-sticky]").forEach((headerRoot) => {
      const stickyContainer =
        headerRoot.closest("#header-group") ||
        headerRoot.closest(".shopify-section");
      stickyContainer?.classList.toggle(
        "fw-header-section--sticky",
        headerRoot.dataset.fwSticky !== "never",
      );
    });
  }

  document.addEventListener("click", (event) => {
    const opener = event.target.closest(SELECTORS.opener);
    if (opener) {
      event.preventDefault();
      setDrawerState(getDrawerForControl(opener), true);
      return;
    }

    const closer = event.target.closest(
      `${SELECTORS.closer}, ${SELECTORS.mobileLink}`,
    );
    if (closer) {
      const drawer =
        closer.closest(SELECTORS.drawer) || getDrawerForControl(closer);
      setDrawerState(drawer, false);
      return;
    }

    document
      .querySelectorAll(".fw-company-switcher[open]")
      .forEach((switcher) => {
        if (!switcher.contains(event.target)) switcher.removeAttribute("open");
      });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeAllDrawers();

    if (event.key !== "Tab") return;
    const drawer = document.querySelector(`${SELECTORS.drawer}.is-open`);
    if (!drawer) return;

    const focusable = Array.from(
      drawer.querySelectorAll(
        'a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])',
      ),
    );
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener("cart:update", (event) => {
    const itemCount = Number(
      event.detail?.resource?.item_count ?? event.detail?.data?.item_count,
    );
    if (!Number.isFinite(itemCount)) return;

    document.querySelectorAll("[data-fw-cart-count]").forEach((badge) => {
      badge.textContent = String(itemCount);
      badge.hidden = itemCount < 1;
    });
  });

  let previousScrollY = window.scrollY;
  let ticking = false;

  function updateScrollHeaders() {
    const currentScrollY = window.scrollY;
    document
      .querySelectorAll('[data-fw-sticky="scroll-up"]')
      .forEach((headerRoot) => {
        const section =
          headerRoot.closest("#header-group") ||
          headerRoot.closest(".shopify-section") ||
          headerRoot;
        const movingDown =
          currentScrollY > previousScrollY && currentScrollY > 140;
        section.classList.toggle("fw-header-is-hidden", movingDown);
      });
    previousScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener(
    "scroll",
    () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateScrollHeaders);
    },
    { passive: true },
  );

  initialiseHeaders();

  document.addEventListener("shopify:section:load", (event) => {
    closeAllDrawers();
    initialiseHeaders(event.target);
  });
  document.addEventListener("shopify:section:unload", closeAllDrawers);
})();
